import { render, staticRenderFns } from "./TankDetails.vue?vue&type=template&id=04942198"
import script from "./TankDetails.vue?vue&type=script&lang=js"
export * from "./TankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04942198')) {
      api.createRecord('04942198', component.options)
    } else {
      api.reload('04942198', component.options)
    }
    module.hot.accept("./TankDetails.vue?vue&type=template&id=04942198", function () {
      api.rerender('04942198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/TankDetails.vue"
export default component.exports